import { PasswordFlowMode } from './../../../services/passwordflowmode';
import { CommonModule } from '@angular/common';
import { Component, NgModule } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { DxFormModule } from 'devextreme-angular/ui/form';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { DxLoadIndicatorModule } from 'devextreme-angular/ui/load-indicator';
import notify from 'devextreme/ui/notify';
import { AuthService } from '../../services';
import { DxTextBoxModule } from 'devextreme-angular';
import { UserLoginRequest } from '../../../classes/infrastructure/request_response/userloginrequest';
import { isNullOrUndefined } from '../../../../tools';
import { UIUtils } from '../../../services/uiutils.service';
import { ServerCommunicatorService } from '../../../services/server-communicator.service';
import { AppStateManageService } from '../../../services/app-state-manage.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../../services/language.service';


@Component({
  selector: 'app-new-password',
  templateUrl: './new-password.component.html',
  styleUrls: ['./new-password.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    DxFormModule,
    DxLoadIndicatorModule,
    DxButtonModule,
    DxTextBoxModule,
  ],
})
export class NewPasswordFormComponent {
  loading = false;
  formData: any = { password: "", confirmpassword: "", otp: '', email: '' };
  useSubmitBehavior: boolean = true;
  // IsPasswordExpired: boolean = false;

  constructor(private authService: AuthService, private router: Router, private uiUtils: UIUtils, private servercommunicator: ServerCommunicatorService, private appStateManage: AppStateManageService,public langService: LanguageService,
        private translate: TranslateService
  ) { }
  
get isMr() {
  return this.langService.currentLang === 'mr';
}
  passwordMode = 'password';
  confirmpasswordMode = 'password';

  togglePasswordVisibility = () => {
    this.passwordMode = this.passwordMode === 'text' ? 'password' : 'text';
  };

  toggleConfirmPasswordVisibility = () => {
    this.confirmpasswordMode = this.confirmpasswordMode === 'text' ? 'password' : 'text';
  };

  // old implementation of verify otp and reset password
//   onSubmit = async () => {
//     // if (this.formData.password == '') {
//     //   await this.uiUtils.showErrorMessage('Information', 'Password can not be blank');
//     //   return
//     // }
//     // else if (this.formData.confirmpassword == '') {
//     //   await this.uiUtils.showErrorMessage('Information', 'Confirm Password can not be blank');
//     //   return
//     // }
//     // else if (this.formData.password != this.formData.confirmpassword) {
//     //   await this.uiUtils.showErrorMessage('Information', 'Password and Confirm Password do not match');
//     //   return
//     // }

//     if (this.formData.password == '') {
//   await this.uiUtils.showErrorMessage(
//     this.isMr ? 'त्रुटी' : 'Error',
//     this.isMr
//       ? 'पासवर्ड रिक्त असू शकत नाही'
//       : 'Password cannot be blank'
//   );
//   return;
// }
// else if (this.formData.confirmpassword == '') {
//   await this.uiUtils.showErrorMessage(
//     this.isMr ? 'त्रुटी' : 'Error',
//     this.isMr
//       ? 'पासवर्डची पुष्टी रिक्त असू शकत नाही'
//       : 'Confirm Password cannot be blank'
//   );
//   return;
// }
// else if (this.formData.password != this.formData.confirmpassword) {
//   await this.uiUtils.showErrorMessage(
//     this.isMr ? 'त्रुटी' : 'Error',
//     this.isMr
//       ? 'पासवर्ड आणि पुष्टी केलेला पासवर्ड जुळत नाही'
//       : 'Password and Confirm Password do not match'
//   );
//   return;
// }

//     this.formData.email = await this.appStateManage.StorageKey.getItem('Email')
//     this.formData.otp = await this.appStateManage.StorageKey.getItem('OTP')
//     let body = {
//       email_id : this.formData.email,
//       otp : this.formData.otp,
//       password : this.formData.password,
//       confirm_password : this.formData.confirmpassword,
//       IsPasswordExpired: this.appStateManage.getPasswordFlowMode()
//     }
//     // this.isVerifyPassword = true;
//     // ---------------------using new mqtt service --------------------
//     const response = await this.servercommunicator.UpdatePassword(
//       'updatepassword',
//       body
//     );
//     console.log(body);

//     if (!response.successful) {
//       await this.uiUtils.showErrorMessage('Error', response.message);
//       // this.isVerifyPassword = false;

//       return
//     }
//     else {
//       // this.isVerifyPassword = false;
//       // await this.uiUtils.showSuccessToster('Password Change Successfuly');
//       await this.uiUtils.showSuccessToster(
//   this.isMr
//     ? 'पासवर्ड यशस्वीरित्या बदलला'
//     : 'Password changed successfully'
// );
//       await this.router.navigate(['login-form']);
//     }
//   }


// new implementation of verify otp and reset password with loading state and better error handling
onSubmit = async () => {
  // Validations (unchanged, already correct)
  if (this.formData.password === '') {
    await this.uiUtils.showErrorMessage(
      this.isMr ? 'त्रुटी' : 'Error',
      this.isMr ? 'पासवर्ड रिक्त असू शकत नाही' : 'Password cannot be blank'
    );
    return;
  }
  if (this.formData.confirmpassword === '') {
    await this.uiUtils.showErrorMessage(
      this.isMr ? 'त्रुटी' : 'Error',
      this.isMr ? 'पासवर्डची पुष्टी रिक्त असू शकत नाही' : 'Confirm Password cannot be blank'
    );
    return;
  }
  if (this.formData.password !== this.formData.confirmpassword) {
    await this.uiUtils.showErrorMessage(
      this.isMr ? 'त्रुटी' : 'Error',
      this.isMr ? 'पासवर्ड आणि पुष्टी केलेला पासवर्ड जुळत नाही' : 'Password and Confirm Password do not match'
    );
    return;
  }

  this.loading = true; // ✅ show loader
  try {
    this.formData.email = await this.appStateManage.StorageKey.getItem('Email');
    this.formData.otp = await this.appStateManage.StorageKey.getItem('OTP');

    const body = {
      email_id: this.formData.email,
      otp: this.formData.otp,
      password: this.formData.password,
      confirm_password: this.formData.confirmpassword,
      IsPasswordExpired: this.appStateManage.getPasswordFlowMode()
    };

    const response = await this.servercommunicator.UpdatePassword('updatepassword', body);

    if (!response.successful) {
      await this.uiUtils.showErrorMessage('Error', response.message);
      return;
    }

    await this.uiUtils.showSuccessToster(
      this.isMr ? 'पासवर्ड यशस्वीरित्या बदलला' : 'Password changed successfully'
    );

    // ✅ Clean up stored OTP and Email after success
    this.appStateManage.StorageKey.removeItem('OTP');
    this.appStateManage.StorageKey.removeItem('Email');

    await this.router.navigate(['login-form']);

  } finally {
    this.loading = false; // ✅ always reset loader
  }
};

  NavigateForgotPassword = () => {
    this.router.navigate(['forgot-password']);
  }
}

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    DxFormModule,
    DxLoadIndicatorModule,
    DxButtonModule,
    DxTextBoxModule,
    NewPasswordFormComponent,
  ],
  exports: [NewPasswordFormComponent]
})
export class NewPasswordFormModule { }
